import { useAction } from "@/hooks/shared";
import { createInvitationHandler } from "@/services";

export const useCreateInvitation = () => useAction(createInvitationHandler);
